import React, { useState, useImperativeHandle, forwardRef, useRef } from "react";
import { RigidBody, CuboidCollider } from "@react-three/rapier";

const COLORS = ["#a855f7", "#ec4899", "#7dd3fc"];
const MAX_BALLS = 22;
let nextId = 1;

const PhysicsBalls = forwardRef((_, ref) => {
    const [balls, setBalls] = useState([]);

    useImperativeHandle(ref, () => ({
        spawn: (point) => {
            setBalls((prev) => {
                const color = COLORS[Math.floor(Math.random() * COLORS.length)];
                const ball = {
                    id: nextId++,
                    position: [
                        point.x + (Math.random() - 0.5) * 1.5,
                        Math.max(point.y + 1.5, 3.5),
                        Math.min(Math.max(point.z, -2), 2),
                    ],
                    color,
                    radius: 0.22 + Math.random() * 0.16,
                };
                return [...prev.slice(-(MAX_BALLS - 1)), ball];
            });
        },
    }));

    return (
        <group>
            {/* floor */}
            <RigidBody type="fixed" colliders={false}>
                <CuboidCollider args={[60, 0.5, 30]} position={[0, -0.5, 0]} />
                {/* containment walls */}
                <CuboidCollider args={[60, 6, 0.5]} position={[0, 3, -3.2]} />
                <CuboidCollider args={[60, 6, 0.5]} position={[0, 3, 7.5]} />
                <CuboidCollider args={[0.5, 6, 30]} position={[-24, 3, 0]} />
                <CuboidCollider args={[0.5, 6, 30]} position={[24, 3, 0]} />
            </RigidBody>
            {balls.map((b) => (
                <RigidBody
                    key={b.id}
                    colliders="ball"
                    position={b.position}
                    restitution={0.72}
                    friction={0.4}
                    linearDamping={0.15}
                >
                    <mesh castShadow>
                        <sphereGeometry args={[b.radius, 20, 20]} />
                        <meshStandardMaterial
                            color={b.color}
                            emissive={b.color}
                            emissiveIntensity={0.9}
                            metalness={0.3}
                            roughness={0.25}
                        />
                    </mesh>
                </RigidBody>
            ))}
        </group>
    );
});

PhysicsBalls.displayName = "PhysicsBalls";

export default PhysicsBalls;
